import { FormControl, FormLabel } from "@chakra-ui/react";
import { isSaplingAddress } from "@umami/chains";

import { AddressTile } from "@/components/AddressTile/AddressTile";

type ToAddressPreviewFieldProps = {
  address: string;
};

export const ToAddressPreviewField = ({ address }: ToAddressPreviewFieldProps) => {
  const isSapling = isSaplingAddress(address);
  const addressType = isSapling ? "sapling" : "implicit";

  return (
    <FormControl>
      <FormLabel width="full">To</FormLabel>
      <AddressTile address={{ type: addressType, pkh: address }} hideBalance />
    </FormControl>
  );
};
